/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getSearchResultObjects, removeItemFromCart } from 'actions/objectActions';
import API from 'constants/api';

import Loading from 'components/common/Loading';
import SearchResults from 'components/archived-object/search/SearchResults';
import { linkObjects, canLinkMultipleObjects } from 'actions/modalActions';
import { useSelector } from 'react-redux';

const SearchResultsView = ({
  objectIds, // List of Object URIs
  selectable, // Checkbox
  linkObjects, // Default function used to link object
  displayParams,
  mode, // Table, Default, Mosaic...
  addLink, // Linking enabled
  orderByPredicate,
  folderUri,
  toggleSorting,
  isPublicUser,
  canLinkMultipleObjects,
  isCart
}) => {
  const [objects, setObjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [multipleObjects, setMultipleObjects] = useState(null);

  const predicate = useSelector(state => state.modal.resources[0]?.predicate);
  
  useEffect(() => {
    window.parent?.resizeIframe();
  });
  
  useEffect(() => {
    if (objectIds.length > 0) {
      setLoading(true);
      getSearchResultObjects(objectIds).then(result => {
        if (!result.error) {
          setObjects(result);
        }
        setLoading(false);
        setTimeout(() => window.parent?.resizeIframe(), 100);
      });
    }
  }, [objectIds]);

  /*
  * When opening search window modal checks whether multiple objects
  * can be linked to the current archived object
  */
  useEffect(() => {
    if (predicate && multipleObjects === null) {
      canLinkMultipleObjects(predicate).then(result => {
        setMultipleObjects(result);
      });
    }
  }, [predicate]);

  if (loading) {
    return <Loading />;
  }

  // Open in tab if modal, otherwise redirect iframe (folder nav)
  const displayLink = uri => {
    let url;
    if (addLink) {
      url = `${API.DAM.INDEX}?main_action=${API.DAM.DISPLAY_OBJECT}?uri=${uri}&${displayParams}`;
    } else {
      url = `${API.DAM.DISPLAY_OBJECT}?uri=${uri}&${displayParams}`;
    }
    if (isCart) {
      url = url + `&fromCart=true&cartUri=${isCart}`;
    }
    return url;
  };
  

  const handleLink = parent.ResourceModal.addLink ?
    object => parent.ResourceModal.addLink(object.uri) : // override
    object => linkObjects(object.uri); // default

  if (isCart) {
    return (
      <SearchResults
        setObjects={setObjects}
        selectable={selectable}
        objects={objects} 
        displayLink={displayLink}
        removeFromCart={object => removeItemFromCart(object.uri)}
        mode={mode}
        defaultImage="images/NoImage.jpg"
        addLink={addLink ? handleLink : null} // null: no link button
        orderByPredicate={orderByPredicate}
        folderUri={folderUri}
        toggleSorting={toggleSorting}
      />
    );
  }

  return (
    <SearchResults
      selectable={selectable}
      objects={objects} 
      displayLink={displayLink}
      addToCart={object => addItemToCartAjax(object.uri)}
      mode={mode}
      defaultImage="images/NoImage.jpg"
      addLink={addLink ? handleLink : null} // null: no link button
      orderByPredicate={orderByPredicate}
      folderUri={folderUri}
      toggleSorting={toggleSorting}
      isPublicUser={isPublicUser}
      canLinkMultipleObjects={multipleObjects}
    />
  );
};

export default connect(null, { linkObjects, canLinkMultipleObjects })(SearchResultsView);
